import React from "react";

import { Box } from "@mui/material";

interface PDFPreviewContainerProps {
  children: React.ReactNode;
}

export const PDFPreviewContainer: React.FC<PDFPreviewContainerProps> = ({ children }) => (
  <Box
    sx={{
      width: "100%",
      height: "100%",
      p: { xs: 0, md: 2 },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    data-test="pdf-preview-container"
  >
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "grey.50",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      data-test="pdf-preview-container-inner"
    >
      {children}
    </Box>
  </Box>
);
